export default "__VITE_ASSET__Dgqy3XpD__"